export default {
  'US': 'United States',
  'UK': 'United Kingdom',
  'JP': 'Japan',
  'CA': 'Canada',
  'NL': 'Netherlands',
  'SE': 'Sweden',
  'IE': 'Ireland',
  'AT': 'Austria',
  'BY': 'Belarus',
  'BG': 'Bulgaria',
  'HR': 'Croatia',
  'CZ': 'Czech republic',
  'DK': 'Denmark',
  'EE': 'Estonia',
  'FI': 'Finland',
  'FR': 'France',
  'DE': 'Germany',
  'GR': 'Greece',
  'HU': 'Hungary',
  'IS': 'Iceland',
  'IT': "Italy",
  'LV': 'Latvia',
  'LT': 'Lithuania',
  'LU': 'Luxembourg',
  'MC': 'Monaco',
  'NO': 'Norway',
  'PL': 'Poland',
  'RO': 'Romania',
  'RU': 'Russia',
  'SK': 'Slovakia',
  'SI': 'Slovenia',
  'ES': 'Spain',
  'CH': 'Switzerland',
  'TR': 'Turkey'

}